import { WarehouseLayoutSchema } from "@redotech/redo-fulfillment-wms-common/schema/warehouse";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const getWarehouseLayoutForLocation = {
  name: "getWarehouseLayoutForLocation" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({ layout: WarehouseLayoutSchema.nullable() }),
};
